export default "__VITE_ASSET__DHd__mCM__"